// extracted by mini-css-extract-plugin
export default {"ParagraphSection":"ParagraphSection_ParagraphSection__S7uP8"};